const actions = {
  // Fetching roles
  FETCH_ROLES: 'Roles/FETCH_ROLES',
  FETCH_ROLES_RECEIVED: 'Roles/FETCH_ROLES_RECEIVED',

  // CRUD
  CREATE_ROLE: 'Roles/CREATE_ROLE',
  CREATE_ROLE_RECEIVED: 'Roles/CREATE_ROLE_RECEIVED',

  FETCH_ROLE: 'Roles/FETCH_ROLE',
  FETCH_ROLE_RECEIVED: 'Roles/FETCH_ROLE_RECEIVED',

  UPDATE_ROLE: 'Roles/UPDATE_ROLE',
  UPDATE_ROLE_RECEIVED: 'Roles/UPDATE_ROLE_RECEIVED',

  DELETE_ROLE: 'Roles/DELETE_ROLE',
  DELETE_ROLE_RECEIVED: 'Roles/DELETE_ROLE_RECEIVED',

  // Permissions assignment
  FETCH_ROLE_PERMISSIONS: 'Roles/FETCH_ROLE_PERMISSIONS',
  FETCH_ROLE_PERMISSIONS_RECEIVED: 'Roles/FETCH_ROLE_PERMISSIONS_RECEIVED',

  ASSIGN_PERMISSION_TO_ROLE: 'Roles/ASSIGN_PERMISSION_TO_ROLE',
  ASSIGN_PERMISSION_TO_ROLE_RECEIVED: 'Roles/ASSIGN_PERMISSION_TO_ROLE_RECEIVED',

  REMOVE_PERMISSION_FROM_ROLE: 'Roles/REMOVE_PERMISSION_FROM_ROLE',
  REMOVE_PERMISSION_FROM_ROLE_RECEIVED: 'Roles/REMOVE_PERMISSION_FROM_ROLE_RECEIVED',

  // User-Role management
  FETCH_USER_ROLES: 'Roles/FETCH_USER_ROLES',
  FETCH_USER_ROLES_RECEIVED: 'Roles/FETCH_USER_ROLES_RECEIVED',

  ASSIGN_ROLE_TO_USER: 'Roles/ASSIGN_ROLE_TO_USER',
  ASSIGN_ROLE_TO_USER_RECEIVED: 'Roles/ASSIGN_ROLE_TO_USER_RECEIVED',

  REMOVE_ROLE_FROM_USER: 'Roles/REMOVE_ROLE_FROM_USER',
  REMOVE_ROLE_FROM_USER_RECEIVED: 'Roles/REMOVE_ROLE_FROM_USER_RECEIVED',

  // UI state
  REQUESTING: 'Roles/REQUESTING',
  RESPONSE_ERROR: 'Roles/RESPONSE_ERROR',
}

export default actions
